import { useParams } from "react-router-dom";
import SoftwareModules from "./SoftwareModules";
import SoftwareModuleDetail from "./SoftwareModuleDetail";

const SoftwarePublicRouter = () => {
  const { softwareSlug = "" } = useParams();

  if (softwareSlug.endsWith("-modules")) {
    return <SoftwareModules />;
  }

  return <SoftwareModuleDetail />;
};

export default SoftwarePublicRouter;
